/** 考勤相关接口 */
import { $post, $download } from '@/api/request'

// 列表查询
export function query (data = {}) {
  return $post({
    url: '/compAttendance/queryByTimeInterval',
    data
  })
}
// 查询所有人的考勤
export function queryAll (data = {}) {
  return $post({
    url: '/compAttendance/queryAllByTimeInterval',
    data
  })
}
// 导出考勤记录
export function compAttendanceExport (data = {}) {
  return $download({
    url: 'compAttendance/export',
    responseType: 'blob',
    data
  })
}
// 新增
export function add (data = {}) {
  return $post({
    url: '/compAttendance/liteCheck',
    data
  })
}

// 考勤异常处理
export function submitAttendanceApply (data = {}) {
  return $post({
    url: '/compApplyAttendance/submitAttendanceApply',
    data
  })
}
// 考勤异常申请记录
export function compApplyAttendanceQuery (data = {}) {
  return $post({
    url: '/compApplyAttendance/query',
    data
  })
}
// 异常考勤详情
export function getApplyDetail (data = {}) {
  return $post({
    url: '/compApplyAttendance/getApplyDetail',
    data
  })
}

// 待自己审核的异常考勤
export function queryApply (data = {}) {
  return $post({
    url: '/compApplyAttendance/queryApply',
    data
  })
}

// 异常考勤审核
export function audit (data = {}) {
  return $post({
    url: '/compApplyAttendance/audit',
    data
  })
}

// 异常考勤审核
export function auditAndNextUser (data = {}) {
  return $post({
    url: '/compApplyAttendance/auditAndNextUser',
    data
  })
}
// 已审批
export function listApplyAudited (data = {}) {
  return $post({
    url: '/compApplyAttendance/listApplyAudited',
    data
  })
}
// 修改
export function update (data = {}) {
  return $post({
    url: '/compApplyAttendance/update',
    data
  })
}
// 已审批
export function sendSmsAuditPersonAgain (data = {}) {
  return $post({
    url: '/compApplyAttendance/sendSmsAuditPersonAgain',
    data
  })
}
// 暂存
export function stagingApply (data = {}) {
  return $post({
    url: '/compApplyAttendance/stagingApply',
    data
  })
}
